<template>
  <div class="menu-mian">
    <el-scrollbar style="height: 100%">
      <el-menu
        :default-openeds="defaultOpens"
        :default-active="activeMenuPath"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409eff"
        :router="true"
        :collapse="collapse"
        class="el-menu-vertical-demo"
      >
        <template v-for="m in menusFun">
          <el-submenu v-if="m.children" :key="m.path" :index="m.path">
            <template slot="title">
              <i :class="m.icon" />
              <span slot="title">{{ m.title }}</span>
            </template>
            <template v-for="cm1 in filterChildren(m.children)">
              <el-submenu v-if="cm1.children" :key="cm1.path" :index="cm1.path">
                <template slot="title">
                  <span slot="title">{{ cm1.title }}</span>
                </template>
                <template v-for="cm2 in filterChildren(cm1.children)">
                  <el-submenu
                    v-if="cm2.children"
                    :key="cm2.path"
                    :index="cm2.path"
                  >
                    <template slot="title">
                      <span slot="title">{{ cm2.title }}</span>
                    </template>
                    <template v-for="cm3 in filterChildren(cm2.children)">
                      <el-menu-item :key="cm3.path" :index="cm3.path">
                        <span slot="title">{{ cm3.title }}</span>
                      </el-menu-item>
                    </template>
                  </el-submenu>
                  <el-menu-item v-else :key="cm2.path" :index="cm2.path">
                    {{ cm2.title }}
                  </el-menu-item>
                </template>
              </el-submenu>
              <el-menu-item v-else :key="cm1.path" :index="cm1.path">
                {{ cm1.title }}
              </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else :key="m.path" :index="m.path">
            <i :class="m.icon" />
            <span slot="title">{{ m.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import MENUS from "@/menu.js";

export default {
  props: {
    // 当前激活菜单的 index
    activeMenuPath: {
      type: String,
      default: "/",
    },
    // 是否水平折叠收起菜单
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      defaultOpens: ["/"],
      menus: MENUS,
    };
  },
  computed: {
    menusFun() {
      const userGrants = this.$store.state.userInfo.userGrants;
      const newArr = [];
      // console.log(this.menus, " this.menus");
      this.menus.forEach((e) => {
        if (e.key == "00") {
          newArr.push(e);
        }
        userGrants.forEach((x) => {
          if (x.key == e.key && x.isGrant == true) {
            newArr.push(e);
          }
        });
      });
      //  console.log(newArr,'newArr')
      return newArr;
    },
  },
  mounted() {
    // console.log(this.menus, 'menus')
  },
  methods: {
    filterChildren: function (arr) {
      const userGrants = this.$store.state.userInfo.userGrants;
      const newArr = [];
      arr.forEach((e) => {
        userGrants.forEach((x) => {
          if (x.key == e.key && x.isGrant == true) {
            newArr.push(e);
          }
        });
        if (e.key == "00") {
          newArr.push(e);
        }
      });
      return newArr.filter((x) => x.title && !x.routeOnly);
      // return arr.filter(x => x.title && !x.routeOnly);
    },
  },
};
</script>

<style lang='less'>
.menu-mian {
  height: 100%;
  .el-scrollbar {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
  }
}
</style>
